var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6569 8.15392L20.0893 10.5864C20.4644 10.9614 20.6751 11.4702 20.6751 12.0006C20.6751 12.531 20.4644 13.0397 20.0893 13.4148L17.6569 15.8472C16.1566 17.3475 14.1217 18.1904 12 18.1904C9.87827 18.1904 7.84344 17.3475 6.34315 15.8472L3.9107 13.4148C3.53563 13.0397 3.32491 12.531 3.32491 12.0006C3.32491 11.4702 3.53563 10.9614 3.9107 10.5864L6.34315 8.15392C7.84344 6.65363 9.87827 5.81078 12 5.81078C14.1217 5.81078 16.1566 6.65363 17.6569 8.15392Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.9a787fbb088165cca7bc599e89784fa1.svg";
export { ForwardRef as ReactComponent };